module.exports = ".consent-history-row {\n  height: 108px; }\n\n.consent-history-element {\n  width: 145px; }\n"